import * as THREE from 'three'
import BIRDS from 'vanta/src/vanta.birds'
export const animateBg = {
  mounted() {
       this.vantaEffect = BIRDS({
           el: this.$refs.vantaRef,
           THREE: THREE,
           backgroundColor: 0xffffff,
           backgroundAlpha: 1,
           color1:0xff0000,
           color2:0xd1ff,
           colorMode:'lerpGradient',
           quantity:5,
           birdSize:1,
           wingSpan:30,
           speedLimit:5,
           separation:20,
           alignment:20,
           cohesion:20
         })
   },
  beforeDestroy() {
     if (this.vantaEffect) {
       this.vantaEffect.destroy()
     }
   },
}



// WEBPACK FOOTER //
// ./src/utils/mixins.js